import { Link } from "react-router-dom";
import type { CaseStudy } from "../content";

export function CaseCard({ study, index }: { study: CaseStudy; index: number }) {
  return (
    <article className={`case-card case-card--${study.tone}`}>
      <Link to={`/work/${study.slug}`} aria-label={`Read the ${study.shortTitle} case study`}>
        <div className="case-card-image">
          <img src={study.image} alt={study.imageAlt} loading="lazy" data-parallax />
          <span>{String(index + 1).padStart(2, "0")}</span>
        </div>
        <div className="case-card-copy">
          <p>{study.kind}</p>
          <h3>{study.shortTitle}</h3>
          <span>{study.summary}</span>
          <div className="case-card-link">Read the case study <i aria-hidden="true">↗</i></div>
        </div>
      </Link>
    </article>
  );
}
